const getDeclarations = (): string[] => [
  'Your cover will start once we’ve reviewed and approved your application.',
  'You don’t have any cover that duplicates this cover (or will cancel the other cover once this policy starts).',
  'You own and occupy the home that this policy covers.',
  'You have one boiler in your property and it is a single natural gas, Liquid Petroleum Gas, or oil boiler, that is designed for domestic use with an output of no more than 70kWh.',
  'Your excess for each claim is £60.',
  'You understand that this policy is not Home Insurance.',
  'You are entitled to an annual boiler service.',
  'This policy will automatically renew. You can cancel auto-renewal at any time before the policy starts or during the policy term free of charge, by contacting us or by logging into My Account.',
];

export { getDeclarations };
